<!--The content below is only a placeholder and can be replaced.-->
<main-loader></main-loader>
<app-modal-window-container> </app-modal-window-container>
<dialog-box></dialog-box>
<router-outlet></router-outlet>